export enum ChatTypeEnum {
  ROOM_MESSAGE = 'ROOM_MESSAGE',
  USER_MESSAGE = 'USER_MESSAGE',
}
